import cn from "@/utils/class-names";

// Helper function to get balance color classes
const getBalanceColorClasses = (
  balance: number | undefined
): {
  bg: string;
  text: string;
} => {
  if (!balance) return { bg: "bg-gray-100", text: "text-gray-500" };
  if (balance < 1000) return { bg: "bg-red-100", text: "text-red-700" };
  if (balance < 3000) return { bg: "bg-orange-100", text: "text-orange-700" };
  return { bg: "bg-green-100", text: "text-green-700" };
};

// Helper function to format balance
const formatBalance = (balance: number | undefined): string => {
  if (balance === undefined || balance === null) return "0";
  return balance.toLocaleString("en-US");
};

interface AdCreditBalanceCellProps {
  userId: string;
  balance?: number;
  onOpenCreditModal: (userId: string) => void;
}

export default function AdCreditBalanceCell({
  userId,
  balance,
  onOpenCreditModal,
}: AdCreditBalanceCellProps) {
  return (
    <button
      onClick={() => onOpenCreditModal(userId)}
      className={cn(
        "cursor-pointer hover:scale-x-110 transition-all px-3 py-1 rounded-full text-sm font-medium",
        getBalanceColorClasses(balance).bg,
        getBalanceColorClasses(balance).text
      )}
    >
      {formatBalance(balance)}
    </button>
  );
}
